import { truncate } from 'lodash'

const COLLECTION_NAME_MAX_LENGTH = 25

export const truncateCollectionName = (collectionName: string) =>
  truncate(collectionName, { length: COLLECTION_NAME_MAX_LENGTH })
